<template>
  <div class="head-top">
    <div class="top-container">
      <div class="top-left" v-if="$route.name == 'knowledge-base'">
        <div class="base-title">论文知库</div>
      </div>
      <div
        class="top-left"
        v-if="['expert-base', 'expertcenter'].includes($route.name)"
      >
        <div class="base-title">专家智库</div>
      </div>
      <div class="top-left" v-if="$route.name == 'members-home'">
        <div class="base-title">会员之家</div>
      </div>
      <div class="top-right">
        <header-user></header-user>
        <div
          class="upload-btn"
          @click="upload"
          v-if="$route.name == 'knowledge-base'"
        >
          用户投稿
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderUser from './HeaderUser'
export default {
  components: { HeaderUser },
  props: {},
  data() {
    return {
      // img: 'https://cfb-bucket.oss-cn-beijing.aliyuncs.com/static/head-back.png'
    }
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    upload() {
      this.$router.push({
        name: 'contribute'
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.header-container {
    width: 100%;
}

.head-top {
    width: 100%;
    height: 220px;
    background-image: url('~@/assets/img/head-back.png');
    background-size: 100% 100%;
    flex-x(flex-start);

    .top-container {
        // width: 78.458%;
        width: 1180px;
        height: 100%;
        flex-x(space-between);
        margin: auto;

        .top-left {
            width: 45%;
            height: 40%;
            // margin-top: 30px;
            flex-y(center, flex-start);

            .base-title {
                width: 144px;
                height: 43px;
                font-size: 36px;
                font-family: TRENDS;
                color: rgba(255, 255, 255, 0.85);
                line-height: 43px;
            }

            .base-desc {
                width: 100%;
                height: 22px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.85);
                line-height: 22px;
                margin-top: 20px;
            }
        }

        .top-right {
            width: 45%;
            // height: 29%;
            flex-y(space-between, flex-end);

            // margin-top: 40px;
            .upload-btn {
                // margin-top: 40px;
                width: 120px;
                height: 40px;
                background: rgba(179, 179, 179, 0.65);
                border-radius: 20px;
                font-size: 14px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 22px;
                flex-center();
                cursor: pointer;
            }
        }
    }
}
</style>
